import { useNavbar } from '@app/atoms/app/navbar.atom.ts';
import { useEffect } from 'react';
import { ProductsGrid } from '@ui/product/products-grid.tsx';
import { useProducts } from '../../entites/product';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { ListControl } from '@ui/common/list-control.tsx';
import { BreadcrumbItem, Breadcrumbs, useDisclosure } from '@heroui/react';
import { ProductFiltersModal } from '@features/subcategories/product-filters-modal';
import { ProductSortModal } from '@features/subcategories/product-sort-modal';
import { Home2 } from 'iconsax-react';
import { DesktopCategoryDashboard } from '../../entites/categories';
import { useMediaQuery } from '@uidotdev/usehooks';

export const SubcategoryPage = () => {
  const set = useNavbar();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const { categoryId, subcategoryId } = useParams<{
    categoryId?: string;
    subcategoryId: string;
  }>();
  const { data } = useProducts({
    categoryIds: [Number(subcategoryId)],
    searchParams,
  });

  const filter = useDisclosure();
  const sort = useDisclosure();

  const isMobile = useMediaQuery('only screen and (max-width : 1023px)');

  useEffect(() => {
    set.subcategory(searchParams.get('st') || '', searchParams.get('ct') || '');
  }, []);

  if (isMobile) {
    return (
      <>
        <ListControl onSort={sort.onOpen} onFilter={filter.onOpen} />
        <ProductsGrid items={data} />
        <ProductFiltersModal
          isOpen={filter.isOpen}
          onOpenChange={filter.onOpenChange}
          setSearchParams={setSearchParams}
          searchParams={searchParams}
          onClose={filter.onClose}
        />
        <ProductSortModal
          isOpen={sort.isOpen}
          onOpenChange={sort.onOpenChange}
          setSearchParams={setSearchParams}
          searchParams={searchParams}
          onClose={sort.onClose}
        />
      </>
    );
  }
  return (
    <div className="flex flex-col container max-w-7xl mx-auto pt-12">
      <Breadcrumbs>
        <BreadcrumbItem href="/">
          <Home2 size="24" color="#9CA5AC" />
        </BreadcrumbItem>
        <BreadcrumbItem color="primary">
          {searchParams.get('ct') || ''}
        </BreadcrumbItem>
      </Breadcrumbs>

      <div className="mt-6">
        <h1 className="text-4xl text-[#222222] font-bold">
          {searchParams.get('ct') || ''}
        </h1>
      </div>

      <DesktopCategoryDashboard
        categoryId={Number(categoryId)}
        subcategoryId={Number(subcategoryId)}
        onSelectCategory={(subcategory) => {
          const params = new URLSearchParams({
            ct: searchParams.get('ct') || '',
            st: subcategory.name || '',
          }).toString();
          navigate(`/category/${categoryId}/${subcategory.id}?${params}`);
        }}
      />
    </div>
  );
};
